import { render, staticRenderFns } from "./lista_actasentrega.vue?vue&type=template&id=f4e5d5fa&scoped=true"
import script from "./lista_actasentrega.vue?vue&type=script&lang=js"
export * from "./lista_actasentrega.vue?vue&type=script&lang=js"
import style0 from "./lista_actasentrega.vue?vue&type=style&index=0&id=f4e5d5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e5d5fa",
  null
  
)

export default component.exports